(() => {
  const init = () => document.querySelectorAll('[data-freewink-mega][data-open-on-hover="true"]').forEach((details) => {
    if (details.dataset.freewinkReady) return;
    let closeTimer;
    const closeOthers = () => document.querySelectorAll('[data-freewink-mega][open]').forEach((item) => { if (item !== details) item.removeAttribute('open'); });
    details.addEventListener('pointerenter', (event) => {
      if (event.pointerType === 'touch' || window.innerWidth < 990) return;
      window.clearTimeout(closeTimer);
      closeOthers();
      details.setAttribute('open', '');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    });
    details.addEventListener('pointerleave', (event) => {
      if (event.pointerType === 'touch') return;
      closeTimer = window.setTimeout(() => {
        details.removeAttribute('open');
        details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      }, 180);
    });
    details.addEventListener('focusout', (event) => {
      if (!details.contains(event.relatedTarget)) details.removeAttribute('open');
    });
    details.dataset.freewinkReady = 'true';
  });
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
